import { Navigation } from "@/components/shared/common/Navigation";
import { Footer } from "@/components/shared/common/Footer";
import { ThemeToggle } from "@/components/shared/ui/theme-toggle";

interface AppLayoutProps {
  children: React.ReactNode;
  showNav?: boolean;
}

export const AppLayout = ({ children, showNav = true }: AppLayoutProps) => {
  return (
    <div className="min-h-screen bg-background flex flex-col overflow-x-hidden">
      {showNav ? (
        <Navigation />
      ) : (
        // Render a lightweight header placeholder so page spacing and ThemeToggle align with Navigation
        <header className="bg-background pt-safe-top" role="banner">
          <div className="container mx-auto px-4 sm:px-6 px-safe py-4">
            <div className="flex items-center justify-between">
              <div />
              <div className="flex items-center">
                <ThemeToggle />
              </div>
            </div>
          </div>
        </header>
      )}
      {
        // Reduce vertical padding for pages that opt out of the full Navigation (auth pages)
      }
      {(() => {
        // Standardized responsive container padding
        // Mobile: px-4 (16px)
        // Tablet: px-6 (24px)
        // Desktop: px-8 (32px)
        // Safe area padding included
        const containerPadding = "px-4 px-safe sm:px-6 lg:px-8";

        // Vertical padding
        const verticalPadding = showNav ? "py-4 md:py-6" : "py-0";

        const mainClass = `flex-1 w-full max-w-7xl mx-auto ${containerPadding} ${verticalPadding}`;

        return (
          <main id="main" className={mainClass}>
            {children}
          </main>
        );
      })()}
      <Footer />
    </div>
  );
};
